import React from "react";
import { graphql } from "gatsby";
import SEO from "../components/seo";
import PropTypes from "prop-types";
import Layout from "../components/layout";
import { Newsletters } from "../components/updates";
import { State } from "../components/updates/context";

const NewslettersPage = ({ data, pageContext: {numPages, currentPage} }) => {
  return (
    <Layout>
      <SEO title="Newsletters" />
      <State>
        <Newsletters pageData={data} numPages={numPages} currentPage={currentPage} />
      </State>
    </Layout>
  );
};

NewslettersPage.propTypes = {
  data: PropTypes.object,
  pageContext: PropTypes.object
};

export default NewslettersPage;

export const pageQuery = graphql`
  query($skip: Int!,  $limit: Int!) {
    allMarkdownRemark(
      sort: { order: DESC, fields: [frontmatter___date] }
      filter: { frontmatter: { newsletter: { eq: true } } }
      limit: $limit
      skip: $skip
    ) {
      edges {
        node {
          id
          frontmatter {
            date(formatString: "MMMM DD, YYYY")
            slug
            title
            image {
              childImageSharp {
                fluid(maxWidth: 400) {
                  ...GatsbyImageSharpFluid
                }
              }
            }
          }
        }
      }
    }
  }
`;
